import getNormalizedParamValue from "./getNormalizedParamValue";

const getVariationIdFromCombo = (configurationId, combo, extraSuffixes) => {
  const parts = combo
    .map((param) => getNormalizedParamValue(param, configurationId, extraSuffixes))
    .filter((s) => s !== "");
  const variationId = `${configurationId}${parts.length ? `-${parts.join("-")}` : ""}`;
  return variationId;
};

export default getVariationIdFromCombo;
